






















































































import {Component, Prop, Vue} from 'vue-property-decorator'
import SwapInput from '@/components/SwapInput.vue'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import {BalanceResponse} from '@/helpers/ShrikeHelper'
import TokenAccountBalance from '@/components/TokenAccountBalance.vue'

@Component({
  components: {
    SwapInput,
    TokenAccountBalance,
  },
})
export default class SwapInputAmount extends Vue {
  @Prop({type: String, required: true}) amount!: string
  @Prop({type: String, required: true}) amountInDollar!: string
  @Prop({type: Array, required: true}) accountBalance!: BalanceResponse[]
  @Prop({required: true}) token!: TokensTableItem | null
  @Prop({type: String, required: true}) maxAmountAvailableToUse!: string
  @Prop({type: Boolean, default: false}) displayToken!: boolean

  tokenAccountBalance = 0
  isMaxAmountToUseSelected = false
  isInputValid = true

  async handleMaxClick() {
    this.$emit('maxClick')
  }

  handleInput(val: string) {
    this.$emit('input', val)
  }

  focusOnInput() {
    const input = this.$el.querySelector(
      '.swap-input-amount__input'
    ) as HTMLInputElement
    input.focus()
  }
}
